<template>
  <v-row align="center" class="mx-auto">
    <v-col cols="12">
      <v-expansion-panels v-model="_panels">
        <v-expansion-panel id="painel-rodadas">
          <v-expansion-panel-header style="font-weight: lighter; font-size: 16px">Editar Rodadas</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-simple-table dense>
              <template v-slot:default>
                <draggable v-bind="dragOptions" v-model="_rodadas" tag="table">
                  <transition-group name="rodadas" tag="tbody">
                    <tr v-for="(rodada, idx) in _rodadas" :key="rodada.key">
                      <td>
                        <strong>{{ idx + 1 }}ª</strong>
                      </td>
                      <td class="pl-1">
                        <v-row align="center" class="mx-auto">
                          <v-col
                            v-for="atributo in atributosRodadas"
                            :key="`${atributo}_${rodada.key}`"
                            cols="auto"
                            class="pl-1 py-0"
                          >
                            <v-checkbox
                              v-model="_rodadas[idx].valores"
                              dense
                              multiple
                              hide-details
                              class="my-0 py-0"
                              :label="atributo"
                              :value="atributo"
                              :error="_rodadas[idx].valores.length == 0"
                            />
                          </v-col>
                          <validation-provider immediate rules="required">
                            <input type="hidden" :name="`validar-rodada-${idx}`" :value="_rodadas[idx].valores" />
                          </validation-provider>
                        </v-row>
                      </td>
                      <td class="pl-0">
                        <v-row align="center" class="mx-auto">
                          <v-col cols="12" sm="5" class="pa-0">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="success" icon v-bind="attrs" @click="duplicarRodada(idx)" v-on="on">
                                  <v-icon size="22">mdi-plus-circle</v-icon>
                                </v-btn>
                              </template>
                              <span>Duplicar Rodada</span>
                            </v-tooltip>
                          </v-col>
                          <v-col v-if="_rodadas.length > 1" cols="12" sm="5" class="pa-0">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="error" icon v-bind="attrs" @click="_rodadas.splice(idx, 1)" v-on="on">
                                  <v-icon size="22">mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Remover Rodada</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>
                  </transition-group>
                </draggable>
              </template>
            </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
  import randomString from '@/utils/generateRandomString';

  export default {
    name: 'GeneralEditarRodadas',

    components: {
      draggable: () => import('vuedraggable')
    },

    props: {
      rodadas: {
        type: Array,
        required: true
      },
      atributosRodadas: {
        type: Array,
        required: true
      },
      panels: {
        type: Number,
        default: undefined
      }
    },

    emits: ['update:rodadas', 'update:panels'],

    computed: {
      dragOptions() {
        return {
          animation: 300,
          ghostClass: 'ghost'
        };
      },
      _rodadas: {
        get() {
          return this.rodadas;
        },
        set(newValue) {
          this.$emit('update:rodadas', newValue);
        }
      },
      _panels: {
        get() {
          return this.panels;
        },
        set(newValue) {
          this.$emit('update:panels', newValue);
        }
      }
    },

    methods: {
      duplicarRodada(idx) {
        this._rodadas.splice(idx + 1, 0, { key: randomString(30), valores: this._rodadas[idx].valores });
      }
    }
  };
</script>

<style>
  .ghost {
    opacity: 0.5;
  }

  .rodadas-enter-active,
  .rodadas-leave-active {
    transition: all 0.45s;
  }
  .rodadas-enter,
  .rodadas-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }
</style>